import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { Observable } from 'rxjs';
import { AddUnitModalComponent } from '../add-unit-modal/add-unit-modal.component';
import { UtilityService } from '../../../services/utility.service'
import * as moment from 'moment';
import { start } from 'repl';

@Component({
  selector: 'app-unit-tile',
  templateUrl: './unit-tile.component.html',
  styleUrls: ['./unit-tile.component.scss']
})
export class UnitTileComponent implements OnInit {

  @Input('unit') unit;
  @Input('index') i: any;
  @Input('courseId') courseId;
  @Input('singleCourse') course
  @Input('assignmentDetails') assignment
  @Input('type') type;
  @Input('viewPage') page
  @Input('quizStatus') quizStatus
  @Input('learner') singleLearner
  @Input('job') selectedJob
  @Input('userRole') userRole
  @Output() unitUpdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(ContextMenuComponent, { static: true }) public basicMenu: ContextMenuComponent;
  public contextMenuActions = [];
  preventSingleClick: boolean;
  timer;
  tooltip: string;
  displayStatus = false
  learner
  singleJob
  statusQuiz
  assignmentDetails
  quizList
  jobIdCurrent
  learnerIdCurrent
  itemlaststatus
  displayconetextmenu
  quizStart
  quizEnd
  quizRelease: boolean = false;

  constructor(private changeDetector: ChangeDetectorRef, public dialog: MatDialog, private router: Router, public _utilityService: UtilityService) {
  }

  ngOnInit() {

    // console.log("what is the single unit data", this.unit);

    console.log("What is selected job : ", this.selectedJob);
    this.fillContextMenu(this.unit)
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("check assigment value", changes)

    if (changes.page && changes.page.currentValue) {
      let page = changes.page.currentValue
      if (page == 'Job') {
        this.displayStatus = false
      } else {
        this.displayStatus = true
      }

    }
    console.log("what is job: ", this.selectedJob)
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      // console.log("what is the current learner value======", changes.singleLearner.currentValue);
      this.learner = changes.singleLearner.currentValue
    }

    if (changes.selectedJob && changes.selectedJob.currentValue) {
      this.singleJob = changes.selectedJob.currentValue
      // console.log("single job value in learner dashboard unit tile", this.singleJob);

    }


    if (changes.assignment && changes.assignment.currentValue) {
      console.log("here is the latest data to print", changes.assignment.currentValue);
      this.assignmentDetails = changes.assignment.currentValue
      this.quizList = this.assignmentDetails.quiz
      this.quizStatus = this.assignmentDetails.quizStatus
      this.jobIdCurrent = this.assignmentDetails.job
      this.learnerIdCurrent = this.assignmentDetails.learner
      if (this.assignmentDetails.quizReleaseData && this.assignmentDetails.quizReleaseData.quizStartDate) {
        this.quizRelease = true
        this.quizStart = this.assignmentDetails.quizReleaseData.quizStartDate + " " + this.assignmentDetails.quizReleaseData.quizStartTime
        this.quizEnd = this.assignmentDetails.quizReleaseData.quizEndDate + " " + this.assignmentDetails.quizReleaseData.quizEndTime
      }
      // this.isDisable = true
      console.log("check updated value:", this.assignmentDetails, this.quizStart, this.quizEnd)

    }

    if (changes.quizStatus && changes.quizStatus.currentValue) {
      this.statusQuiz = changes.quizStatus.currentValue;
      this.displayStatus = true
    }

    if (changes.userRole && changes.userRole.currentValue) {
      this.userRole = changes.userRole.currentValue;
      console.log("userRole-------> ", this.userRole);
    }

  }
  // UTILITY FUNCTIONS
  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }



  getStatusClass(item) {

    if (item.status) {
      // console.log("what is item", item);
      switch (item.status) {
        case 'Submitted':
          this.tooltip = 'Submitted';
          return 'submitted'
          break;

        case 'Completed':
          this.tooltip = 'Completed';
          return 'completed'
          break;

        case 'Requested for Resubmission':
          this.tooltip = 'Requested for Resubmission';
          return 'requested'
          break;

        case 'Re-Submitted':
          this.tooltip = 'Re-Submitted';
          return 'resubmitted'
          break;

        case 'Saved':
          this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          this.tooltip = 'Pending';
          return 'pending'
          break;
      }
    } else {
      console.log("this is else part");

      this.tooltip = 'Pending';
      return 'pending'
    }
  }


  /**
   * status class for quiz
   */
  getStatusClassforquiz(unit) {
    // console.log("quiz item display here ========>", unit)
    let selectedquiz = this.statusQuiz.filter(function (item) {
      if (item.quizId == unit._id) {
        return item
      }
    })

    // console.log("single item value after filter", selectedquiz);
    if (selectedquiz && selectedquiz.length) {
      this.itemlaststatus = selectedquiz[0].assessmentList.slice(-1)[0]

      switch (this.itemlaststatus.status) {
        case 'Submitted':
          this.tooltip = 'Submitted';
          // console.log("submited work or not");
          return 'submitted'
          break;

        case 'Completed':
          this.tooltip = 'Completed';
          // console.log("completed work switch")
          return 'completed'
          break;

        case 'Requested for Resubmission':
          this.tooltip = 'Requested for Resubmission';
          return 'requested'
          break;

        case 'Re-Submitted':
          this.tooltip = 'Re-Submitted';
          return 'resubmitted'
          break;

        case 'Saved':
          this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          this.tooltip = 'Pending';
          return 'pending'
          break;
      }
    } else {
      this.tooltip = 'Pending';
      return 'pending'
    }

  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  fillContextMenu(unit) {
    // console.log("fillContextMenu function called", unit)
    // if(this.type != 'appear-quiz'){
    if (unit) {
      let obj = {
        html: (item) => 'Edit Unit',
        click: (item) => unit,
        enabled: (item) => true,
        visible: (item) => 'type1',
      }
      this.contextMenuActions.push(obj)
      // console.log("this.contextMenuActions", this.contextMenuActions)
    }
    this.changeDetector.detectChanges();
    // console.log("this.contextMenuActions", this.contextMenuActions)
    // }
  }

  openEditModal(data) {
    console.log("openEditModal", data)
    // if(this.type !='appear-quiz'){
    data['isEdit'] = true
    this.openDialog(AddUnitModalComponent, data).subscribe(res => {
      console.log("edited unit", res)
      if (res == undefined) return
      else {
        this.unitUpdate.emit(res)
      }
    })
    //  }
  }


  doubleClick(event) {
    console.log("Double Click Event", event);
    this.preventSingleClick = true;
    console.log("Double Click");
    console.log("singleFolder");
    console.log('this.unit', this.unit)
    // let id = singleFolder._id;
    if (this.type == 'material') {
      // let navigationExtras: NavigationExtras = {
      //   state: {
      //     role: this.userRole
      //   }
      // };
      let param = {
        userRole: this.userRole
      }
      this.router.navigate(['/course/material/', this.courseId, this.unit._id], { queryParams: param })
      // this.router.navigate(['/material/', this.courseId, this.unit._id], navigationExtras)
    }
    else if (this.type == 'appear-quiz') {
      // console.log("appearquiz work sucessfully unit id:", this.unit._id)
      // console.log('jobid', this.jobIdCurrent)
      console.log('leanreriD', this.userRole)

      let startDate = moment(this.quizStart, "MM/DD/YYYY hh:mm A")
      let endDate = moment(this.quizEnd, "MM/DD/YYYY hh:mm A")
      console.log("start end date time: ", startDate.diff(moment()), endDate.diff(moment()), moment().format('MM/DD/YYYY hh:mm A'), this.quizRelease)

      if (this.quizRelease) {
        if (startDate.diff(moment()) < 0 && endDate.diff(moment()) > 0) {
          this.router.navigate(['/quiz/appear-quiz'], { queryParams: { quizId: this.unit._id, learnerId: this.learnerIdCurrent, jobId: this.jobIdCurrent, userRole: this.userRole } })
        }
        else {
          if (startDate.diff(moment()) > 0) {
            this._utilityService.handleSnackBar({ msg: "Quiz will Start at: " + this.quizStart, button: "Ok" });
          }
          else if (endDate.diff(moment()) < 0) {
            this._utilityService.handleSnackBar({ msg: "Quiz has been ended", button: "Ok" });
          }
        }
      }
      else {
        this.router.navigate(['/quiz/appear-quiz'], { queryParams: { quizId: this.unit._id, learnerId: this.learnerIdCurrent, jobId: this.jobIdCurrent, userRole: this.userRole } })
      }

    }
    else {
      console.log("My route called", this.unit)
      // if (this.learner && this.learner._id) {
      //   console.log("first of cond");

      //   this.router.navigate(['/session'], { queryParams: { sessionId: this.unit._id, sessionType: this.unit.sessionType, learnerId: this.learner._id, jobId: this.singleJob._id } })
      // } else {
      //   console.log("second if cond");

      //   this.router.navigate(['/session'], { queryParams: { sessionId: this.unit._id, sessionType: this.unit.sessionType } })
      // }

    }
    if (this.type == 'material') {
      this.displayconetextmenu = true
    }
    else {
      this.displayconetextmenu = false

    }
  }


}
